<div
  class="form-autocomplete"
  [class.form-autocomplete--error]="hasError"
  [class.form-autocomplete--disabled]="disabled"
  [class.form-autocomplete--open]="isOpen"
  (keydown.esc)="hideSuggestions()"
>
  <app-form-autocomplete-trigger
    [triggerId]="id"
    [disabled]="disabled"
    [hasError]="hasError"
    [placeholder]="placeholder"
    [formControl]="triggerControl"
    [tabindex]="tabindex"
    [ariaLabel]="ariaLabel"
    (focusInput)="focusInputTrigger()"
    (clearInput)="clearInputTrigger()"
    (ngModelChange)="setSuggestion($event)"
    [inputStyle]="inputStyle"
    [inputIcon]="inputIcon"
    [isClearable]="isClearable"
  ></app-form-autocomplete-trigger>

  <app-form-autocomplete-list
    [triggerId]="id"
    [isOpen]="isOpen"
    [suggestions]="suggestionsDisplayed"
    [listStyle]="listStyle"
    (selectSuggestion)="setSelectedSuggestion($event)"
    data-test="autocomplete-list"
  ></app-form-autocomplete-list>
</div>
